import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { Link, useSearch } from '@tanstack/react-router';

import { Tooltip } from 'components/common/Tooltip';
import { IconLivestream } from 'components/icons';
import { useAspenLogger } from 'hooks/useAspenLogger';

import { AppDeviceLeaf } from 'types/common/leaf';

interface LivestreamProps {
  leafId: AppDeviceLeaf['id'];
}

export const Livestream = ({ leafId }: LivestreamProps) => {
  const { eventId } = useSearch({ from: '/events' });
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Live stream" placement="top">
      <Link to="/$camera" params={{ camera: leafId }}>
        <IconButton
          aria-label="livestream"
          data-testid="button-livestream"
          onClick={() => {
            if (eventId) {
              logAspenEvent({
                log_id: 'iot.web.event.interaction',
                payload: {
                  event_id: eventId,
                  interaction: 'livestream',
                },
              });
            }
          }}
          sx={{
            '&.MuiIconButton-root': {
              display: 'inline-flex',
              padding: '0', // Override RDS padding
            },
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          <IconLivestream sx={{ color: colors.grey[400] }} />
        </IconButton>
      </Link>
    </Tooltip>
  );
};
